(function () {
  'use strict';

  // Cards are server-rendered from the pop_flavor metaobjects.
  // This script handles sorting and the filter tabs only.
  //
  // CRO 2026-09-17: unavailable flavours are rendered too (faded, chipped) so
  // the catalogue stays browsable and indexable. Default view is the
  // Featured Fifteen — what a customer can actually order today.

  var grid = document.querySelector('[data-flavor-library-grid]');
  if (!grid) return;

  var tabs = document.querySelectorAll('.popbar-tab');
  var note = document.querySelector('[data-flavor-library-note]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.popbar-flavor-card'));
  if (!cards.length) return;

  function sortKey(el) {
    // data-sort is "<0|2>-<type>-<featured_order>"
    var parts = (el.getAttribute('data-sort') || '').split('-');
    return {
      off: parseInt(parts[0], 10) || 0,
      type: parts[1] || 'gelato',
      order: parseInt(parts[2], 10) || 99
    };
  }

  cards
    .slice()
    .sort(function (a, b) {
      var ka = sortKey(a);
      var kb = sortKey(b);
      if (ka.off !== kb.off) return ka.off - kb.off;           // available first
      if (ka.type !== kb.type) return ka.type === 'gelato' ? -1 : 1;
      if (ka.order !== kb.order) return ka.order - kb.order;
      return (a.getAttribute('data-flavor-name') || '')
        .localeCompare(b.getAttribute('data-flavor-name') || '');
    })
    .forEach(function (card) { grid.appendChild(card); });

  function apply(filter) {
    var showingAny = false;
    cards.forEach(function (card) {
      var type = card.getAttribute('data-flavor-type');
      var avail = card.getAttribute('data-flavor-available') !== 'false';
      var show;
      if (filter === 'all') show = true;
      else if (filter === 'available') show = avail;
      else show = avail && type === filter;
      card.hidden = !show;
      if (show) showingAny = true;
    });
    if (note) note.hidden = filter !== 'all';
    if (!showingAny) grid.setAttribute('data-empty', 'true');
    else grid.removeAttribute('data-empty');
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      apply(tab.getAttribute('data-tab'));
    });
  });

  apply('available');
})();
